export default "__VITE_ASSET__BYuOhITs__"